export default {"src":"/_next/static/media/california-state.57beb7f5.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};